import { getAuthHeaders, BASE_URL } from './inquiries';

export const getTemplates = async () => {
    const response = await fetch(`${BASE_URL}/api/crm/templates`, {
        headers: getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Failed to fetch templates');
    return response.json();
};

export const createTemplate = async (data) => {
    const response = await fetch(`${BASE_URL}/api/crm/templates`, {
        method: 'POST',
        headers: {
            ...getAuthHeaders(),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error('Failed to create template');
    return response.json();
};

export const updateTemplate = async (id, data) => {
    const response = await fetch(`${BASE_URL}/api/crm/templates/${id}`, {
        method: 'PATCH',
        headers: {
            ...getAuthHeaders(),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error('Failed to update template');
    return response.json();
};

export const deleteTemplate = async (id) => {
    const response = await fetch(`${BASE_URL}/api/crm/templates/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Failed to delete template');
    return response.json();
};

export const getStatusSnapshot = async () => {
    const response = await fetch(`${BASE_URL}/api/crm/status`, {
        headers: getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Failed to fetch status snapshot');
    return response.json();
};

export const getPerformanceStats = async (period = '1w') => {
    const response = await fetch(`${BASE_URL}/api/crm/performance?period=${period}`, {
        headers: getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Failed to fetch performance stats');
    return response.json();
};

export const getWebStats = async (period = '1w') => {
    const response = await fetch(`${BASE_URL}/api/crm/web-stats?period=${period}`, {
        headers: getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Failed to fetch web stats');
    return response.json();
};

export const getReferrers = async (period = '1w', limit = 10) => {
    const response = await fetch(`${BASE_URL}/api/crm/referrers?period=${period}&limit=${limit}`, {
        headers: getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Failed to fetch referrers');
    return response.json();
};

export const getAnalysis = async (type, period = '1w', unit = 'day') => {
    const response = await fetch(`${BASE_URL}/api/crm/analysis?type=${type}&period=${period}&unit=${unit}`, {
        headers: getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Failed to fetch analysis');
    return response.json();
};




// --- Quick Links ---

export const getQuickLinks = async () => {
    const response = await fetch(`${BASE_URL}/api/crm/quick-links`, {
        headers: getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Failed to fetch quick links');
    return response.json();
};

export const createQuickLink = async (data) => {
    const response = await fetch(`${BASE_URL}/api/crm/quick-links`, {
        method: 'POST',
        headers: {
            ...getAuthHeaders(),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error('Failed to create quick link');
    return response.json();
};

export const deleteQuickLink = async (id) => {
    const response = await fetch(`${BASE_URL}/api/crm/quick-links/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Failed to delete quick link');
    return response.json();
};
